module.exports = __webpack_public_path__ + "img/3-11-ford-plaza.b6b9897f.jpg";